<template>
    <!-- 用户列表 -->
    <vRoleField :postList="postList" v-if="flag"></vRoleField>
</template>
<script>
import vRoleField from '../listComponent/jurisdiction/roleFieldComponent.vue';
export default {
    name: 'roleField',
    components: {
        vRoleField
    },
    data() {
        return {
            postList: {
                headerTitle: true,
                object_type: true,
                searchBtn: true,
                resetBtn: true,
                setBtn: true
            },
            flag: false
        };
    },

    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>